import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { snowplow, constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import ModalWithActions from 'components/modal/ModalWithActions/ModalWithActions'
import { openChangeFrequencyModal } from 'compositions/modals/changeFrequency'

import messages from './messages'


const placement = 'unpause subscription popup'

export default class UnpauseSubscriptionModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    data: PropTypes.object,
  }

  static defaultProps = {
    name: constants.modals.pauseSubscription.UnpauseSubscription,
  }

  componentDidMount() {
    const { data: { modalId } } = this.props

    snowplow.track(constants.snowplowEvents.subscriptionUnpausePopup, { modalId }, false)
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  unpause = () => {
    snowplow.track('Unpause click', { placement }, false)

    actions.models.subscription.unpause({ placement })
    this.close()
  }

  unpauseAndChangeFreq = () => {
    const { data: { modalId } } = this.props

    this.close()

    openChangeFrequencyModal({
      popup: `popup ${modalId}`,
      withFeedback: true,
    })
  }

  getActions = () => {
    const { data: { modalId } } = this.props

    return [
      {
        brand: true,
        title: messages.buttonUnpause,
        onClick: this.unpause,
      },
      // hiding this button until card update is capable of changing frequency
      // {
      //  brand: true,
      //  title: messages.buttonUnpauseAndChangeFreq,
      //  onClick: this.unpauseAndChangeFreq,
      //  key: 'buttonUnpauseAndChangeFreq',
      // },
      {
        whiteGray: true,
        title: messages[`buttonSkip${modalId}`],
        onClick: this.close,
      },
    ]
  }

  render() {
    const { name, data: { modalId } } = this.props

    return (
      <ModalWithActions
        name={name}
        title={messages[`title${modalId}`]}
        actions={this.getActions()}
      >
        <FormattedHTMLMessage tag="div" {...messages[`text${modalId}`]} />
      </ModalWithActions>
    )
  }
}
